var _path, _g, _g2, _g3, _g4, _g5, _circle, _circle2, _circle3, _g6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOptimizeCharts1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "optimize-chart-1",
    width: 671,
    height: 335,
    viewBox: "0 0 671 335",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M0 10.9062C164.068 10.9062 160.848 263.101 260.838 263.101C343.928 263.101 375.49 16.4241 522.766 152.341C567.844 193.943 610.237 225.295 669.386 175.958",
    stroke: "url(#paint0_linear_1352_24252)",
    strokeWidth: 4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bar-1"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M194.48 120.141H191.995L191.995 143.456H177.117V261.875L189.911 266.531H191.995V285.19L204.788 289.846H207.273V266.531H222.151L222.151 148.112L209.357 143.456H207.273V124.797L194.48 120.141ZM189.911 148.112L189.911 261.875V148.112H204.788L189.911 148.112Z",
    fill: "url(#paint1_linear_1352_24252)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M191.995 120.141H194.48V143.456H209.357V261.875H194.48V285.19H191.995V261.875H177.117V143.456H191.995V120.141Z",
    fill: "url(#paint2_linear_1352_24252)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "bar-2"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M250.449 61.332H247.964V84.6473H233.086V203.066L245.879 207.723H247.964V226.381L260.757 231.038H263.242V207.723H278.12V89.3037L265.326 84.6473H263.242V65.9884L250.449 61.332ZM245.879 89.3037L245.879 203.066V89.3037H260.757L245.879 89.3037Z",
    fill: "url(#paint3_linear_1352_24252)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M247.964 61.332H250.449V84.6473H265.326V203.066H250.449V226.381H247.964V203.066H233.086V84.6473H247.964V61.332Z",
    fill: "url(#paint4_linear_1352_24252)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "bar-3"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M303.94 0.5V23.8153L303.94 23.8153H303.94H289.062V238.669L301.856 243.326H303.94V261.876L316.733 266.533H319.219V243.326H334.096V28.4718L334.096 28.4717L321.303 23.8153H319.219V5.15646L319.219 5.1564L306.425 0.5V1.40455L303.94 0.5ZM301.856 28.4718H321.303V28.4717L319.219 28.4717H316.733L316.733 28.4717H301.856L301.856 28.4718Z",
    fill: "url(#paint5_linear_1352_24252)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M303.94 0.5H306.425V23.8153H303.94V0.5ZM289.062 23.8153H321.303V238.669H306.425V261.876H303.94V238.669H289.062V23.8153Z",
    fill: "url(#paint6_linear_1352_24252)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "bar-4"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M359.909 120.141H362.394L375.187 124.797V143.456H377.272L390.065 148.112V299.805H375.187V323.12H372.702L359.909 318.464V299.805H357.825L345.031 295.148V143.456H359.909L359.909 120.141Z",
    fill: "url(#paint7_linear_1352_24252)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M362.394 120.141H359.909V143.456H345.031V295.148H359.909V318.464H362.394V295.148H377.272V143.456H362.394V120.141Z",
    fill: "url(#paint8_linear_1352_24252)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "bar-5"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M415.878 63.4297H418.363L431.156 68.0861L431.156 86.745H433.24L446.034 91.4014V243.094H431.156V266.409H428.671L415.878 261.753V243.094H413.793L401 238.437V86.745H415.878L415.878 63.4297Z",
    fill: "url(#paint9_linear_1352_24252)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M418.363 63.4297H415.878V86.745L401 86.745V238.437H415.878V261.753H418.363V238.437H433.24V86.745L418.363 86.745V63.4297Z",
    fill: "url(#paint10_linear_1352_24252)"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 390.066,
    cy: 43.937,
    r: 2.09714,
    fill: "#7551FF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 191.136,
    cy: 63.4292,
    r: 2.09714,
    fill: "#7551FF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 311.574,
    cy: 332.015,
    r: 2.09714,
    fill: "#7551FF"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "optimize-pen"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 143.539,
    y: 7.42578,
    width: 13.4556,
    height: 170.463,
    rx: 4,
    transform: "rotate(45 143.539 7.42578)",
    fill: "url(#paint11_linear_1352_24252)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.711 10.2542C142.273 8.69211 144.805 8.69211 146.367 10.2542L150.225 14.1119C151.787 15.674 151.787 18.2067 150.225 19.7688L142.405 27.5886L132.891 18.0741L140.711 10.2542Z",
    fill: "#E0D8FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1352_24252",
    x1: 669.386,
    y1: 137.003,
    x2: 0,
    y2: 137.003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7551FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7551FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1352_24252",
    x1: 199.634,
    y1: 120.141,
    x2: 199.634,
    y2: 289.846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8A5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAAAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1352_24252",
    x1: 193.237,
    y1: 120.141,
    x2: 193.237,
    y2: 285.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0139996,
    stopColor: "#A488FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.224,
    stopColor: "#A488FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C5AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1352_24252",
    x1: 255.603,
    y1: 61.332,
    x2: 255.603,
    y2: 231.038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8A5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAAAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1352_24252",
    x1: 249.206,
    y1: 61.332,
    x2: 249.206,
    y2: 226.381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0139996,
    stopColor: "#A488FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.224,
    stopColor: "#A488FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C5AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1352_24252",
    x1: 311.579,
    y1: 0.5,
    x2: 311.579,
    y2: 266.533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8A5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAAAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1352_24252",
    x1: 305.183,
    y1: 0.5,
    x2: 305.183,
    y2: 261.876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0139996,
    stopColor: "#A488FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.224,
    stopColor: "#A488FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C5AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1352_24252",
    x1: 367.548,
    y1: 120.141,
    x2: 367.548,
    y2: 323.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8A5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAAAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1352_24252",
    x1: 361.151,
    y1: 120.141,
    x2: 361.151,
    y2: 318.464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0139996,
    stopColor: "#A488FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.224,
    stopColor: "#A488FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C5AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1352_24252",
    x1: 423.517,
    y1: 63.4297,
    x2: 423.517,
    y2: 266.409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8A5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAAAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1352_24252",
    x1: 417.12,
    y1: 63.4297,
    x2: 417.12,
    y2: 261.753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0139996,
    stopColor: "#A488FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.224,
    stopColor: "#A488FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C5AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1352_24252",
    x1: 150.267,
    y1: 7.42578,
    x2: 150.267,
    y2: 177.889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A488FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8565FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptimizeCharts1);
export default __webpack_public_path__ + "static/media/OptimizeCharts1.2528d5c94c05b430fb8a13318cee9353.svg";
export { ForwardRef as ReactComponent };